<div class="explorer-wrapper" (swipeleft)="previousCountry()" (swiperight)="nextCountry()">
  <div class="countrybar">
    <span *ngFor="let country of countries" [ngClass]="{
      'selectedCountry': country === selectedCountry,
      'country': true 
    }"
    (click)="selectCountry(country)">
        <img src="{{ country.flagImagePath }}" />
    </span>
  </div>
  <section class="front-page">
    <div class="explorer-header">
      <button class="countryLeftArrow" (click)="previousCountry()">
        &#10094;
      </button>
      <span class="text-right">
        {{ selectedCountry.name }}
      </span>
      <button class="countryRightArrow" (click)="nextCountry()">
        &#10095;
      </button>
    </div>
    <div class="explorer-content">
      <div class=" front-page-flag">
        <img src="{{ selectedCountry.flagImagePath }}" />
      </div>
    </div>
  </section>

  <section *ngFor="let city of selectedCountry.cities">
    <div class="explorer-header {{ city.colorClass }}">
      <span class="text-right">{{ city.name }}</span>
    </div>
    <div class="explorer-content">
      <div class="explorer-image-left">
        <img src="{{ city.photo1path }}" />
      </div>
      <div class="explorer-image-right">
        <img src="{{ city.photo2path }}" />
      </div>
    </div>
  </section>

  <div class="whitebar"></div>
</div>
